// extracted by mini-css-extract-plugin
module.exports = {"rentalTitle":"nN","boxArtWrapper":"nO","rentalArtwork":"nP","rentalName":"nQ"};